import mod from "-!./totalSpr.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./totalSpr.js?vue&type=script&lang=js&external"